import { useCallback } from 'react';

const useUpdateButtonVisibility = (
  setShowPreviousButton: (show: boolean) => void,
  setShowNextButton: (show: boolean) => void
) => {
  return useCallback<(carouselRefCurrent: HTMLDivElement | null, contentRefCurrent: HTMLDivElement | null) => void>(
    (carouselRefCurrent, contentRefCurrent) => {
      if (!contentRefCurrent || !carouselRefCurrent) {
        return;
      }

      if (carouselRefCurrent.scrollLeft > 0) {
        setShowPreviousButton(true);
      } else {
        setShowPreviousButton(false);
      }

      if (carouselRefCurrent.scrollLeft + carouselRefCurrent.offsetWidth >= contentRefCurrent.offsetWidth) {
        setShowNextButton(false);
      } else {
        setShowNextButton(true);
      }
    },
    [setShowNextButton, setShowPreviousButton]
  );
};

export default useUpdateButtonVisibility;
